<template>
  <div>
    <div class="header">
      <span>{{ data.date | tripDate }}</span>
    </div>
    <ul class="list-reset trip-list fs-14 mb-12">
      <li v-for="(trip, index) in data.trips" :key="trip.id">
        <a
          :href="supplierUrlByDate(trip)"
          class="trip-item trip-status-available relative"
          :class="[
            {
              'border-t':
                index > 0 &&
                !hasDiscount(data.trips[index - 1]) &&
                hasDiscount(trip),
            },
            getTripClass(trip),
          ]"
          target="_blank"
        >
          <span class="font-medium">
            {{ formatDates(trip) }}
          </span>
          <div>
            <svg
              width="24"
              height="24"
              class="inline-block"
              fill="currentColor"
            >
              <use xlink:href="/img/sprite.svg#ic_calendar"></use>
            </svg>
            {{ trip.length + 1 }}D / {{ trip.length }}N
          </div>
          <div>
            <h4 class="fs-16 font-medium whitespace-normal">
              <span v-html="trip.platform_name" />
            </h4>
            <div class="whitespace-normal mt-1">
              {{ trip.trip_name }}
            </div>
          </div>

          <div class="font-medium text-center availablity-text">
            <span>
              {{ trip.availability | formatAvailability }}
            </span>
          </div>

          <div>
            <div class="discount-tag" v-if="hasDiscount(trip)">
              <template
                v-if="
                  trip.discount_method === 'fix_amount' && trip.discount_price
                "
              >
                -
                <currency-context>
                  <template v-slot="{ convert }">
                    <span v-text="convert(trip.discount_price)"></span>
                  </template>
                </currency-context>
              </template>
              <template
                v-else-if="
                  trip.discount_method === 'percentage' && trip.discount_price
                "
              >
                {{ trip.discount_price }}% off
              </template>
              <template v-else-if="trip.discount_method === 'custom'">
                Special rate
              </template>
            </div>

            <div
              class="relative flex price-box"
              :data-discount-method="trip.discount_method"
            >
              <span class="font-medium">
                <currency-context>
                  <template v-slot="{ convert }">
                    <span v-text="convert(trip.price.price)"></span>
                  </template>
                </currency-context>
              </span>
              &nbsp;/guest

              <div
                class="old-price line-through"
                v-if="hasDiscount(trip) && trip.discount_price"
              >
                <currency-context>
                  <template v-slot="{ convert }">
                    <span v-text="convert(trip.price.real_price)"></span>
                  </template>
                </currency-context>
              </div>
            </div>
          </div>
        </a>
      </li>
    </ul>
  </div>
</template>

<script>
import { mapState, mapMutations, mapGetters } from "vuex";
import LiveaboardItemMixin from "../../mixins/LiveaboardItemMixin";
import chunk from "lodash/chunk";
import { displayDate } from "../../helpers/index";
import CurrencyContext from "../core/CurrencyContext";

const PER_PAGE = 12;

export default {
  mixins: [LiveaboardItemMixin],
  components: { CurrencyContext },
  props: ["data"],
  computed: {
    ...mapState(["view", "page"]),
    ...mapGetters(["sortedResults", "selectedMonth"]),
  },
  methods: {
    supplierUrlByDate(trip) {
      let query = `?from=${trip.date}`;

      const guests = this.guests;
      if (guests !== "0") {
        query = query + `&guests=${guests}`;
      }

      return `${trip.platform_url}${query}`;
    },
    formatDates(trip) {
      const start_date = moment(trip.date, "YYYY-MM-DD");
      const end_date = moment(trip.date, "YYYY-MM-DD").add(trip.length, "days");
      return displayDate(start_date, end_date);
    },
  },
};
</script>

<style scoped>
.resort-item .price-cta {
  position: absolute;
  top: 0;
  right: 0;
  text-align: right;
}

.header {
  font-size: 18px;
  padding: 12px 24px;
  background-color: #727272;
  color: white;
  border-top-left-radius: 0.25rem;
  border-top-right-radius: 0.25rem;
  font-weight: 500;
  z-index: 1;
}

.trip-item {
  align-items: center;
  display: grid;
  grid-template-columns: 110px 100px 1fr 110px 125px;
  grid-column-gap: 12px;
  min-height: 70px;
  line-height: 24px;
  padding: 12px 24px;
  border-bottom: 1px solid var(--black-light-2);
  border-right: 1px solid var(--black-light-2);
  border-left: 1px solid var(--black-light-2);
}

li:nth-child(2n + 1) {
  background-color: var(--black-light-1);
}

li:last-child {
  border-bottom-left-radius: 0.25rem;
  border-bottom-right-radius: 0.25rem;
}

li:first-child {
  border-top: 1px solid var(--black-light-2);
  border-top-left-radius: 0.25rem;
  border-top-right-radius: 0.25rem;
}

.trip-item.trip-discounted {
  border-color: var(--discount-primary);
  background-color: var(--discount-basis-bg);
  min-height: 80px;
}

.trip-item.trip-discounted .price-box:not([data-discount-method="custom"]) {
  top: 10px;
}

.trip-item:not(.trip-discounted) + .trip-item.trip-discounted {
  border-top: 1px solid var(--discount-primary);
}

.trip-item.trip-discounted .discount-tag {
  white-space: nowrap;
  position: absolute;
  background-color: var(--discount-primary);
  color: white;
  font-size: 12px;
  border-bottom-left-radius: 4px;
  line-height: 16px;
  padding: 1px 10px;
  top: 0px;
  right: 0px;
}

.trip-item:not(:first-child) .discount-tag {
  border-top-right-radius: 0px;
  border-bottom-right-radius: 0px;
  border-top-left-radius: 0px;
}

.old-price {
  position: absolute;
  top: -20px;
  left: 0px;
  line-height: 16px;
  font-size: 12px;
  color: var(--black-light-5);
}

.border-t {
  border-top: 1px solid;
}

@media (min-width: 601px) and (max-width: 1200px) {
  .trip-item .availablity-text {
    line-height: 16px;
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
}
</style>
